import React, { useEffect } from "react"
import ReactQuill, { type DeltaStatic } from "react-quill-new"
import "react-quill-new/dist/quill.bubble.css"
import { registerPopopoImageBlot } from "../quill/PopopoImageBlot"

type Props = {
  content: string | DeltaStatic
  className?: string
}

export function QuillViewer({ content, className }: Props) {
  useEffect(() => {
    registerPopopoImageBlot()
  }, [])

  return (
    <div className={className}>
      <ReactQuill
        value={content}
        readOnly={true}
        theme="bubble"
        modules={{
          toolbar: false
        }}
      />
      <style>{`
        .ql-container.ql-bubble {
          border: none;
          font-size: inherit;
        }
        .ql-editor {
          padding: 0;
          font-size: inherit;
        }
        .ql-editor p {
          margin-bottom: 0.5rem;
        }
        .ql-editor:last-child {
          margin-bottom: 0;
        }
      `}</style>
    </div>
  )
}
